<div class="cardform">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="jobForm" (ngSubmit)="onSubmit()">
        <div class="step-content">
          <ng-container *ngIf="isLoading; else loadedContent">
            <div class="loading">Carregando funções/postos...</div>
          </ng-container>
          <ng-template #loadedContent>
            <ng-container *ngIf="error; else jobContent">
              <div class="error">{{error}}</div>
            </ng-container>
            <ng-template #jobContent>
              <!-- Corrige o select para não quebrar se job for undefined -->
              <mat-form-field appearance="outline" class="full-width">
                <mat-label>Selecione a função/posto</mat-label>
                <mat-select formControlName="job" (selectionChange)="onJobSelected($event.value)">
                  <ng-container *ngIf="celebration">
                    <ng-container *ngFor="let job of celebration.jobList">
                      <!-- Opção para selecionar o grupo inteiro -->
                      <mat-option [value]="'group-' + job.uuid" class="group-option">
                        Todos - {{job.name}} {{job.activeStaff}} de {{job.maxStaff}}
                      </mat-option>
                      <!-- Opções individuais -->
                      <mat-option *ngFor="let location of job.locationList" [value]="location.locationUuid">
                        {{location.name}} {{location.activeStaff}} de {{location.maxStaff}}
                      </mat-option>
                    </ng-container>
                  </ng-container>
                </mat-select>
              </mat-form-field>

              <!-- Cards de Jobs -->
              <div class="jobs-grid">
                <ng-container *ngIf="celebration">
                  <ng-container *ngFor="let job of getSortedJobs()">
                    <ng-container *ngFor="let jobLocation of job.locationList; let i = index">
                      <mat-card
                        class="job-card"
                        [class.selected]="jobLocation.locationUuid === jobForm.get('job')?.value"
                        (click)="onJobCardSelect(jobLocation.locationUuid)"
                        *ngIf="shouldShowCard(job, jobLocation)">
                        <mat-card-header *ngIf="i === 0">
                            <div  mat-card-avatar class="job-icon">
                              <mat-icon>work</mat-icon>
                            </div>
                            <mat-card-title >{{job.name}}</mat-card-title>
                          </mat-card-header>
                          <mat-card-content>
                            <div class="job-details-row">
                              <mat-icon class="job-details-icon">person_outline</mat-icon>
                              <div class="job-details-info">
                                <div class="job-details-name">{{jobLocation.name}}</div>
                                <div class="job-details-duration">Duração: {{formatDuration(jobLocation.defaultJobTimeInMinutes)}}</div>
                                <div class="staff-number">
                                  <span [style.color]="getJobStatusColor(job)">Ativos: {{jobLocation.activeStaff}} de {{jobLocation.maxStaff}} /Min({{jobLocation.minStaff}})</span>
                                </div>
                              </div>
                            </div>
                          </mat-card-content>
                      </mat-card>
                      <div *ngIf="i === job.locationList.length - 1" class="job-group-separator"></div>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
              <div class="actions">
                <button mat-raised-button color="primary" class="custom-button" [disabled]="jobForm.invalid" (click)="onSubmit()">Próximo</button>
              </div>
            </ng-template>
          </ng-template>
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
